import DetailsView from 'components/DetailsView';
import DetailsViewCard from 'components/DetailsViewCard';
import DetailsViewCloseButton from 'components/DetailsViewCloseButton';
import Map from 'components/Map';
import Page from 'components/Page';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailsViewPageContainer: FunctionComponent<Props> = ({
    children,
    flights,
    geometry,
    handleClose,
    handleEditMapClick,
    handleEditMapClose,
    handleMapComplete,
    hasDrawingControls = false,
    mapFlightPaths,
    mapInteractionOptions,
    mapOptions,
    prescriptionBounds,
    prescriptionZones,
    selectedFlight,
    telemetryPointsByFlightId,
    testId = TEST_ID
}) => (
    <Page className={styles.detailsViewPageContainer} testId={testId}>
        {!hasDrawingControls && <DetailsViewCloseButton onClick={handleClose} />}

        <DetailsView className={styles.detailsView} isEditingMap={hasDrawingControls}>
            <DetailsViewCard className={styles.detailsViewCard}>{children}</DetailsViewCard>

            <Map
                flightPaths={mapFlightPaths ?? flights}
                geometry={geometry}
                mapInteractionOptions={mapInteractionOptions}
                mapOptions={mapOptions}
                onClickEditMap={handleEditMapClick}
                onClose={handleEditMapClose}
                onComplete={handleMapComplete}
                prescriptionBounds={prescriptionBounds}
                prescriptionZones={prescriptionZones}
                selectedFlight={selectedFlight}
                telemetryPointsByFlightId={telemetryPointsByFlightId}
            />
        </DetailsView>
    </Page>
);

export default DetailsViewPageContainer;
